import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { State } from '../store/reducers';

export const useAuth = () => {
  const auth = useSelector((state: State) => state.auth);
  const isLoggedIn = !!auth;
  const isRole = useCallback((role) => auth && auth.roles.includes(role), [auth]);
  const isAgent = isRole('Agent');
  const isExpert = isRole('Expert');

  return { auth, isLoggedIn, isAgent, isExpert };
};
